export default __webpack_public_path__ + "static/social-card-9bb0505302e0ee8d7c8d8b538332dfc1.png";